/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

export const useMiscellaneousStyles = makeStyles((theme: Theme) => ({
  loaderContainer: {
    height: '100%',
    maxHeight: '500px',
    minHeight: '150px',
  },
  successColor: {
    color: theme.palette.success.main,
  },
  failureColor: {
    color: theme.palette.error.main,
  },
}));
